var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['spacing-container', _vm.currentStyle],style:(_vm.cssVars)})}
var staticRenderFns = []

export { render, staticRenderFns }